import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, RolePackageData } from './types'

export const selectRolePackageListEvent = (state: RootState): Event =>
  state.manageRolePackageReducer.listEvent

export const selectRolePackageList = (state: RootState): ListData => state.manageRolePackageReducer.list

export const selectRolePackageActionEvent = (state: RootState): Event =>
  state.manageRolePackageReducer.actionEvent

export const selectAllRolePackageList = (state: RootState): RolePackageData[] =>
  state.manageRolePackageReducer.allRolePackage

export const selectRefreshPermissionEvent = (state: RootState): Event =>
  state.manageRolePackageReducer.refreshEvent
